import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

export default function FloatingButtons() {
  const [showScroll, setShowScroll] = useState(false);

  useEffect(() => {
    const handleScroll = () => setShowScroll(window.scrollY > 400);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <div className="fixed bottom-6 right-6 z-40 flex flex-col items-center gap-3">
      {/* Scroll to top */}
      <AnimatePresence>
        {showScroll && (
          <motion.button
            initial={{ opacity: 0, scale: 0.5, y: 20 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.5, y: 20 }}
            transition={{ duration: 0.3, ease: "easeOut" }}
            onClick={scrollToTop}
            className="w-12 h-12 flex items-center justify-center rounded-full bg-dark-300 border border-white/10 text-white/60 hover:text-gold hover:border-gold/30 transition-smooth cursor-pointer shadow-lg"
            aria-label="Yukarı çık"
          >
            <i className="ri-arrow-up-line text-lg"></i>
          </motion.button>
        )}
      </AnimatePresence>

      {/* WhatsApp */}
      <motion.a
        initial={{ opacity: 0, scale: 0.5 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.4, delay: 0.8, ease: "easeOut" }}
        href="https://wa.me/905056622000"
        target="_blank"
        rel="noopener noreferrer"
        className="w-14 h-14 flex items-center justify-center rounded-full bg-[#25D366] text-white hover:scale-110 hover:shadow-[0_0_24px_rgba(37,211,102,0.4)] transition-smooth cursor-pointer shadow-lg"
        aria-label="WhatsApp ile iletişim"
      >
        <i className="ri-whatsapp-line text-2xl"></i>
      </motion.a>
    </div>
  );
}
